import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import formatTimeLeft from '../../common/helpers/formatTimeLeft';
import parsePostContent from '../../common/helpers/parsePostContent';
export default class ArenaBattleNextTurnPost extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "timerId", null);
  }
  /**
   * Whether the battle has visibly moved past this prompt: any later
   * battle post means this post's expiresAt snapshot is stale (a wait
   * post resets the timer server-side; a resolved turn or a final post
   * supersedes it entirely), so its countdown must not keep ticking —
   * old turns looked like several timers running in parallel. Checks
   * only posts already loaded into the store, i.e. exactly what the
   * viewer sees in the stream; regular user comments don't count.
   */
  isSuperseded() {
    var _post$discussion, _post$number, _discussion$posts, _discussion$posts2;
    const post = this.attrs.post;
    const discussion = (_post$discussion = post.discussion) == null ? void 0 : _post$discussion.call(post);
    if (!discussion) return false;
    const myNumber = (_post$number = post.number()) != null ? _post$number : 0;
    return ((_discussion$posts = (_discussion$posts2 = discussion.posts) == null ? void 0 : _discussion$posts2.call(discussion)) != null ? _discussion$posts : []).some(p => {
      var _p$number, _p$number2, _p$contentType, _p$contentType2;
      return p && p.id() !== post.id() && ((_p$number = (_p$number2 = p.number) == null ? void 0 : _p$number2.call(p)) != null ? _p$number : 0) > myNumber && ArenaBattleNextTurnPost.LATER_BATTLE_POST_TYPES.includes((_p$contentType = (_p$contentType2 = p.contentType) == null ? void 0 : _p$contentType2.call(p)) != null ? _p$contentType : '');
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.timerId = setInterval(() => m.redraw(), 60000);
  }
  onremove(vnode) {
    if (this.timerId) clearInterval(this.timerId);
    super.onremove(vnode);
  }
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;
    const turn = data.turn,
      nextPlayerId = data.nextPlayerId,
      nextPlayerName = data.nextPlayerName,
      challengerId = data.challengerId,
      expiresAt = data.expiresAt;
    const isNextChallenger = nextPlayerId === challengerId;
    const timeLeft = this.isSuperseded() ? null : formatTimeLeft(expiresAt != null ? expiresAt : null);
    return m("div", {
      className: "ArenaBattleNextPost EventPost"
    }, m("div", {
      className: "ArenaBattleNextPost-heading"
    }, m("i", {
      className: "fas fa-dungeon"
    }), m("span", null, app.translator.trans('forumaker-arena.forum.battle.turn_heading', {
      turn: String(turn)
    }))), m("div", {
      className: "ArenaBattleNextPost-whosTurn"
    }, m("i", {
      className: "fas fa-".concat(isNextChallenger ? 'caret-right' : 'caret-left')
    }), app.translator.trans('forumaker-arena.forum.battle_next.whos_turn', {
      name: m("strong", null, nextPlayerName)
    }), timeLeft && m("span", {
      className: "ArenaBattleNextPost-timer",
      title: app.translator.trans('forumaker-arena.forum.card_slider.timer_title')
    }, m("i", {
      className: "fas fa-clock"
    }), " ", timeLeft)));
  }
}
/** Battle event posts that can only appear AFTER this turn prompt. */
_defineProperty(ArenaBattleNextTurnPost, "LATER_BATTLE_POST_TYPES", ['arenaBattleTurn', 'arenaBattleWait', 'arenaBattleNext', 'arenaBattleSurrender', 'arenaBattleExpired', 'arenaBattleDraw']);
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleNextTurnPost', ArenaBattleNextTurnPost);